/* OKTGN — Suppléments personnalisation · v9 · thème brouillon
   • Flocage dos (Prénom/Numéro) → variant 58403343237445 · 4,90€ (OPT-IN, payant)
   • Logo personnalisé → OFFERT (plus de supplément payant)
   v8 : chaque flocage = 1 ligne panier avec SES Prénom/Numéro + vignette dynamique
        (canvas police jersey) → on ne se perd plus avec plusieurs pièces.
   v9 (21/08) : 1. une synchro demandée pendant qu'une autre tourne n'est plus
        perdue — c'est ce qui faisait payer UN supplément pour NEUF tenues
        (#OKTGN1112) ; 2. le supplément porte la propriété « Sur » qui liste les
        tenues concernées, pour savoir quel nom va sur quelle pièce. */
(function () {
  var SUPP_VARIANT = 58403343237445;   // Flocage dos (Prénom + Numéro) · 4,90€
  var SUPP_HANDLE = 'flocage-dos-prenom-numero-supplement';
  var FLO_KEYS = ['Prénom', 'Numéro'];
  var FLOC = 4.90, LOGO = 2.90; // logo = offert (LOGO gardé pour compat, inutilisé)

  function fire(el) { try { el.dispatchEvent(new Event('change', { bubbles: true })); } catch (_) { var e = document.createEvent('HTMLEvents'); e.initEvent('change', true, false); el.dispatchEvent(e); } }

  /* ---------- Opt-in flocage dos ---------- */
  function installOptIn() {
    var boxes = document.querySelectorAll('.oktgn-flo');
    for (var i = 0; i < boxes.length; i++) {
      var box = boxes[i];
      var noFloc = box.querySelector('[data-no-flocage]');
      if (!noFloc || box.getAttribute('data-optin-installed')) continue;
      box.setAttribute('data-optin-installed', '1');
      if (!noFloc.checked) { noFloc.checked = true; fire(noFloc); }
      var origRow = noFloc.closest('.oktgn-flo__check') || noFloc.parentElement;
      if (origRow) origRow.style.display = 'none';
      var optin = document.createElement('label');
      optin.className = 'oktgn-flo__optin';
      optin.style.cssText = 'display:flex;align-items:center;gap:10px;margin:0 0 6px;padding:13px 14px;background:#fff;border:1px solid rgba(0,0,0,.14);border-radius:2px;cursor:pointer;user-select:none;font-size:14px;line-height:1.35;color:#0a0a0a;font-weight:600;';
      optin.innerHTML = '<input type="checkbox" class="oktgn-flo__optin-cb" style="width:18px;height:18px;flex-shrink:0;accent-color:#0a0a0a;cursor:pointer;"><span style="flex:1 1 auto">Ajouter un flocage dos · Prénom + Numéro</span><strong style="flex:0 0 auto;margin-left:10px;white-space:nowrap;font-family:Oswald,sans-serif;font-weight:600;font-size:14px;letter-spacing:.01em;color:#c0392b">+4,90€</strong>';
      var head = box.querySelector('.oktgn-flo__head');
      if (head && head.parentElement === box) head.insertAdjacentElement('afterend', optin); else box.insertBefore(optin, box.firstChild);
      (function (cb, nf) { cb.addEventListener('change', function () { nf.checked = !cb.checked; fire(nf); updateTotal(); }); })(optin.querySelector('.oktgn-flo__optin-cb'), noFloc);
    }
  }

  /* ---------- Logo : +2,90€ GROS ---------- */
  function installLogoPrice() {
    // Logo = OFFERT partout (section produit .oktgn-flo__logo-* ET modal cross-sell .oktgn-flo-modal__logo-*)
    var opts = document.querySelectorAll('.oktgn-flo__logo-optional, .oktgn-flo-modal__logo-optional');
    for (var i = 0; i < opts.length; i++) {
      if (opts[i].getAttribute('data-offert')) continue;
      opts[i].setAttribute('data-offert', '1');
      opts[i].innerHTML = '<strong style="color:#0a8a3c;font-size:15px">Offert</strong>';
    }
    var dls = document.querySelectorAll('.oktgn-flo__logo-drop-label, .oktgn-flo-modal__logo-drop-label');
    for (var j = 0; j < dls.length; j++) {
      if (/offert/i.test(dls[j].textContent)) continue;
      dls[j].innerHTML = 'Ajouter mon logo <strong style="color:#0a8a3c;font-size:14px">· Offert</strong>';
    }
  }

  function hideOffertBadge() {
    var bs = document.querySelectorAll('.oktgn-flo .oktgn-flo__badge');
    for (var i = 0; i < bs.length; i++) if (/offert/i.test(bs[i].textContent || '')) bs[i].style.display = 'none';
  }

  /* ---------- Total LIVE sous le bouton ---------- */
  function parsePrice(txt) {
    var t = (txt || '').replace(/[^\d.,]/g, '').replace(/\.(?=\d{3}\b)/g, '').replace(',', '.');
    var v = parseFloat(t); return isNaN(v) ? null : v;
  }
  function basePrice() {
    var scope = document.querySelector('.product__info-container') || document.querySelector('product-form') || document;
    var big = scope.closest ? (scope.closest('.product') || document) : document;
    var cand = document.querySelector('.product__info-container .price--large .price-item--sale:not(.visually-hidden)')
      || document.querySelector('.product__info-container .price--large .price-item--regular:not(.visually-hidden)')
      || document.querySelector('.product__info-container .price-item--sale:not(.visually-hidden)')
      || document.querySelector('.product__info-container .price-item--regular:not(.visually-hidden)');
    return cand ? parsePrice(cand.textContent) : null;
  }
  function optionsSelected() {
    var t = 0, box = document.querySelector('.oktgn-flo');
    if (box) {
      var noFloc = box.querySelector('[data-no-flocage]'), nm = box.querySelector('[data-name-input]'), nu = box.querySelector('[data-num-input]');
      if (noFloc && !noFloc.checked && ((nm && nm.value.trim()) || (nu && nu.value.trim()))) t += FLOC;
      // logo = offert → pas ajouté au total
    }
    return t;
  }
  function updateTotal() {
    var pf = document.querySelector('product-form');
    if (!pf) return;
    var el = document.getElementById('oktgn-livetotal');
    if (!el) {
      el = document.createElement('div');
      el.id = 'oktgn-livetotal';
      el.style.cssText = 'margin:10px 0 0;text-align:center;font-size:15px;font-weight:800;color:#0a0a0a;letter-spacing:0.01em;';
      pf.insertAdjacentElement('afterend', el);
    }
    var base = basePrice(), opt = optionsSelected();
    if (base == null) { el.style.display = 'none'; return; }
    if (opt > 0) {
      el.style.display = 'block';
      el.innerHTML = 'Total avec tes options : <span style="color:#c0392b">' + (base + opt).toFixed(2).replace('.', ',') + '€</span> <span style="font-weight:500;color:#6a6a6a;font-size:13px">(dont +' + opt.toFixed(2).replace('.', ',') + '€ perso)</span>';
    } else { el.style.display = 'none'; }
  }

  /* ---------- Panier : réconciliation (v4) ---------- */
  var busy = false;
  function getCart() { return rawFetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }
  function hasAnyKey(it, keys) { var p = it.properties || {}; for (var i = 0; i < keys.length; i++) if (p[keys[i]]) return true; return false; }
  function loadProv() { try { return new Set(JSON.parse(sessionStorage.getItem('oktgnFloProv') || '[]')); } catch (_) { return new Set(); } }
  function saveProv(s) { try { var a = []; s.forEach(function (x) { a.push(x); }); sessionStorage.setItem('oktgnFloProv', JSON.stringify(a)); } catch (_) {} }
  var again = false;
  function reconcile() {
    // Une demande qui arrive pendant un traitement n'est plus jetee : elle est
    // mise en attente et rejouee a la fin. Sans ca, un changement de quantite
    // fait pendant la synchro ne se voit jamais dans le supplement.
    if (busy) { again = true; return Promise.resolve(); }
    busy = true;
    return getCart().then(function (cart) {
      var items = cart.items || [];
      // 1. Groupes VOULUS : signature Prénom|Numéro des articles floqués (hors supplément) + lignes gardées
      var want = {}; // sig -> { qty, props, lines }
      items.forEach(function (it) {
        if (it.variant_id === SUPP_VARIANT) return;
        var p = it.properties || {};
        var pren = (p['Prénom'] || '').toString(), num = (p['Numéro'] || '').toString();
        if (!pren && !num) return;
        var sig = pren + '|' + num;
        if (!want[sig]) { want[sig] = { qty: 0, props: {}, lines: [] }; if (pren) want[sig].props['Prénom'] = pren; if (num) want[sig].props['Numéro'] = num; }
        want[sig].qty += it.quantity; want[sig].lines.push(it);
      });
      // 2. Lignes supplément EXISTANTES par signature
      var have = {};
      items.forEach(function (it) {
        if (it.variant_id !== SUPP_VARIANT) return;
        var p = it.properties || {};
        have[(p['Prénom'] || '') + '|' + (p['Numéro'] || '')] = { qty: it.quantity, key: it.key };
      });
      // 3. Diff → ops, en distinguant AJOUT initial vs SUPPRESSION volontaire (set "provisionnés")
      var prov = loadProv(), ops = [];
      Object.keys(want).forEach(function (sig) {
        var w = want[sig], h = have[sig];
        if (h) {
          if (h.qty !== w.qty) ops.push({ type: 'change', key: h.key, qty: w.qty });
          prov.add(sig); // en phase → provisionné
        } else if (prov.has(sig)) {
          // supplément SUPPRIMÉ par le client → le rashguard redevient nu. Shopify ne modifie pas les
          // propriétés d'une ligne → on ré-ajoute le rashguard SANS Prénom/Numéro (d'abord), puis on retire l'ancien.
          w.lines.forEach(function (it) {
            var np = {}, op = it.properties || {};
            Object.keys(op).forEach(function (k) { if (k !== 'Prénom' && k !== 'Numéro') np[k] = op[k]; });
            ops.push({ type: 'strip', addId: it.variant_id, addQty: it.quantity, addProps: np, removeKey: it.key });
          });
          prov['delete'](sig);
        } else {
          // Le supplement porte la liste des tenues concernees : a la lecture de
          // la commande, on sait quel nom va sur quelle piece.
          var pieces = w.lines.map(function (l) {
            return (l.variant_title || l.product_title || '').replace(/ \/ Noir| \/ Blanc/g, '')
                   + (l.quantity > 1 ? ' x' + l.quantity : '');
          }).filter(Boolean).join(' · ');
          if (pieces) w.props['Sur'] = pieces;
          ops.push({ type: 'add', props: w.props, qty: w.qty }); // 1er ajout
          prov.add(sig);
        }
      });
      Object.keys(have).forEach(function (sig) { if (!want[sig]) { ops.push({ type: 'change', key: have[sig].key, qty: 0 }); prov['delete'](sig); } });
      saveProv(prov);
      return ops.reduce(function (chain, op) {
        return chain.then(function () {
          if (op.type === 'add') return rawFetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: SUPP_VARIANT, quantity: op.qty, properties: op.props }] }) });
          if (op.type === 'strip') {
            var addBody = { id: op.addId, quantity: op.addQty }; if (op.addProps && Object.keys(op.addProps).length) addBody.properties = op.addProps;
            return rawFetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Oktgn-Xsell': '1' }, body: JSON.stringify({ items: [addBody] }) })
              .then(function () { return rawFetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: op.removeKey, quantity: 0 }) }); });
          }
          return rawFetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: op.key, quantity: op.qty }) });
        });
      }, Promise.resolve()).then(function () { if (ops.length) { refreshCartUI(); setTimeout(refreshCartUI, 450); setTimeout(refreshCartUI, 1200); } });
    }).catch(function (e) { try { console.warn('[OKTGN flocage] reconcile', e); } catch (_) {} }).then(function () {
      busy = false;
      if (again) { again = false; setTimeout(reconcile, 120); }   // on rejoue ce qui a ete demande pendant
    });
  }

  /* ---------- Les suppléments flocage toujours SOUS les produits dans le panier ---------- */
  function isSuppRow(row) { return !!row.querySelector('a[href*="' + SUPP_HANDLE + '"]'); }
  function sinkSupplements() {
    try {
      var rows = document.querySelectorAll('cart-drawer tr.cart-item, cart-notification tr.cart-item, .drawer__cart-items-wrapper tr.cart-item, .cart-items tr.cart-item');
      var byParent = [];
      for (var i = 0; i < rows.length; i++) {
        var r = rows[i], p = r.parentElement; if (!p) continue;
        var slot = null; for (var j = 0; j < byParent.length; j++) if (byParent[j].parent === p) { slot = byParent[j]; break; }
        if (!slot) { slot = { parent: p, list: [] }; byParent.push(slot); }
        slot.list.push(r);
      }
      byParent.forEach(function (slot) {
        var prod = [], supp = [];
        slot.list.forEach(function (r) { (isSuppRow(r) ? supp : prod).push(r); });
        if (!supp.length) return;
        var desired = prod.concat(supp);
        var already = true;
        for (var k = 0; k < slot.list.length; k++) { if (slot.list[k] !== desired[k]) { already = false; break; } }
        if (already) return; // VRAIMENT idempotent : rien à bouger → pas de mutation → pas de boucle
        desired.forEach(function (r) { slot.parent.appendChild(r); });
      });
    } catch (_) {}
  }
  var _sinkObs = null;
  function watchDrawerForSink() {
    var cd = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!cd || _sinkObs) return;
    _sinkObs = new MutationObserver(function () { sinkSupplements(); paintFloThumbs(); verrouilleSupplement(); });
    _sinkObs.observe(cd, { childList: true, subtree: true });
    sinkSupplements(); paintFloThumbs();
  }

  /* ---------- Vignette panier = flocage RÉEL (Prénom + Numéro saisis) ---------- */
  var FLO_FONT_URL = 'https://cdn.shopify.com/s/files/1/1065/6094/6501/files/AdiCupQ2022.ttf?v=1778764771';
  var _floFont = null;
  function ensureFloFont() {
    if (_floFont) return _floFont;
    try {
      if (!window.FontFace) { _floFont = Promise.resolve(false); return _floFont; }
      var ff = new FontFace('OKTGNJersey', 'url(' + FLO_FONT_URL + ')');
      _floFont = ff.load().then(function (f) { document.fonts.add(f); return true; }).catch(function () { return false; });
    } catch (e) { _floFont = Promise.resolve(false); }
    return _floFont;
  }
  function renderFloThumb(name, num, ok) {
    var S = 300, c = document.createElement('canvas'); c.width = S; c.height = S;
    var ctx = c.getContext('2d');
    ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, S, S);
    ctx.fillStyle = '#0a0a0a'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    var fam = ok ? "'OKTGNJersey', sans-serif" : 'sans-serif';
    var nm = (name || '').toUpperCase();
    if (nm) {
      var fs = 54; ctx.font = '700 ' + fs + 'px ' + fam;               // réduit (66→54)
      while (ctx.measureText(nm).width > 226 && fs > 14) { fs -= 3; ctx.font = '700 ' + fs + 'px ' + fam; }
      ctx.fillText(nm, S / 2, num ? 82 : 150);                          // remonté → plus d'écart
    }
    if (num) {
      var us = 116; ctx.font = '700 ' + us + 'px ' + fam;              // réduit (150→116)
      while (ctx.measureText(num).width > 196 && us > 22) { us -= 6; ctx.font = '700 ' + us + 'px ' + fam; }
      ctx.fillText(num, S / 2, nm ? 216 : 150);                        // descendu → plus d'écart
    }
    return c.toDataURL('image/png');
  }
  function parseFlo(row) {
    var txt = (row.textContent || '').replace(/\s+/g, ' ');
    // s'arrête aussi au PRIX (€/£/$/x,xx) : sans numéro, le prix suit le prénom et était aspiré ("ABIN €4,90")
    var mn = txt.match(/Pr[ée]nom\s*:\s*(.*?)\s*(?:Num[ée]ro\s*:|R[ée]duire|Retirer|Supprimer|Quantit|€|£|\$|\d+[.,]\d{2}|$)/i);
    var mu = txt.match(/Num[ée]ro\s*:\s*([0-9]{1,3})/i);
    var name = (mn ? mn[1] : '').replace(/[€£$].*$/, '').replace(/\s*\d+[.,]\d{2}.*$/, '').trim().slice(0, 14);
    return { name: name, num: mu ? mu[1].trim() : '' };
  }
  function paintFloThumbs() {
    ensureFloFont().then(function (ok) {
      var rows = document.querySelectorAll('cart-drawer tr.cart-item, cart-notification tr.cart-item, .cart-items tr.cart-item');
      for (var i = 0; i < rows.length; i++) {
        var row = rows[i];
        if (!row.querySelector('a[href*="' + SUPP_HANDLE + '"]')) continue;
        var fl = parseFlo(row);
        if (!fl.name && !fl.num) continue;
        var img = row.querySelector('img'); if (!img) continue;
        var sig = fl.name + '|' + fl.num + '|' + (ok ? 'f' : 'x');
        if (img.getAttribute('data-flo-sig') === sig) continue;
        img.setAttribute('data-flo-sig', sig);
        try { img.removeAttribute('srcset'); img.srcset = ''; } catch (_) {}
        img.src = renderFloThumb(fl.name, fl.num, ok);
      }
    });
  }

  function refreshCartUI() {
    rawFetch(window.location.pathname + '?sections=cart-drawer,cart-icon-bubble,cart-notification-product').then(function (r) { return r.json(); }).then(function (secs) {
      function swap(html, liveSel, freshSel) {
        try {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector(freshSel) || doc.body.firstElementChild;
          var live = document.querySelector(liveSel);
          if (fresh && live) live.innerHTML = fresh.innerHTML;
        } catch (_) {}
      }
      // 1. tiroir : on remplace le CONTENU de <cart-drawer> (pas #shopify-section-*, qui n'existe pas ici)
      swap(secs['cart-drawer'], 'cart-drawer', 'cart-drawer');
      // 2. notification (si le thème l'utilise à la place du tiroir)
      swap(secs['cart-notification-product'], 'cart-notification', 'cart-notification');
      // 3. badge compteur
      swap(secs['cart-icon-bubble'], '.cart-count-bubble', '.cart-count-bubble');
      // 4. fallback : sections par id (autres thèmes)
      try { Object.keys(secs).forEach(function (name) { var cur = document.getElementById('shopify-section-' + name); if (cur) { var dd = new DOMParser().parseFromString(secs[name], 'text/html'); var ff = dd.querySelector('#shopify-section-' + name) || dd.body.firstElementChild; if (ff) cur.innerHTML = ff.innerHTML; } }); } catch (_) {}
      sinkSupplements(); paintFloThumbs(); watchDrawerForSink();
    }).catch(function () {});
  }


  /* ---------- v9 : la ligne supplement ne se supprime pas a la main ----------
     Sans ca, le client retire le supplement du panier et garde son flocage sur
     la tenue. Le script sait rattraper (il enleve alors le nom), mais c'est
     exactement le genre d'aller-retour ou une synchro se perd. Plus simple :
     on empeche le geste, et on renvoie vers la case a cocher de la fiche. */
  function verrouilleSupplement() {
    var lignes = document.querySelectorAll('.cart-item, tr.cart-item, .cart-items tr, cart-drawer-items .cart-item');
    for (var i = 0; i < lignes.length; i++) {
      var l = lignes[i];
      if (l.getAttribute('data-oktgn-verrou')) continue;
      var lien = l.querySelector('a[href*="' + SUPP_HANDLE + '"]');
      if (!lien) continue;
      l.setAttribute('data-oktgn-verrou', '1');
      var bouton = l.querySelector('cart-remove-button, .cart-remove-button, a[href*="quantity=0"]');
      if (bouton) bouton.style.display = 'none';
      var qte = l.querySelector('quantity-input, .quantity');
      if (qte) qte.style.pointerEvents = 'none';
      var note = document.createElement('small');
      note.style.cssText = 'display:block;margin-top:4px;color:#666;font-size:12px;line-height:1.3';
      note.textContent = 'Se règle depuis la fiche produit, avec le nom.';
      if (lien.parentElement) lien.parentElement.appendChild(note);
    }
  }

  /* ---------- Wrap de fetch : reconcile sur tout appel panier ---------- */
  var rawFetch = window.fetch ? window.fetch.bind(window) : function (u, o) { return fetch(u, o); };
  if (window.fetch && !window.__oktgnCartWrapped) {
    window.__oktgnCartWrapped = true;
    var orig = window.fetch.bind(window);
    window.fetch = function () {
      var a0 = arguments[0], u = (typeof a0 === 'string') ? a0 : (a0 && a0.url) || '';
      var pr = orig.apply(window, arguments);
      try { if (/\/cart\/(add|change|update|clear)/.test(u)) pr.then(function () { setTimeout(reconcile, 250); }).catch(function () {}); } catch (_) {}
      return pr;
    };
  }

  /* ---------- Déclencheurs ---------- */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || String(f.action).indexOf('/cart/add') === -1) return;
    if (f.closest && (f.closest('cart-drawer') || f.closest('cart-notification'))) return;
    setTimeout(reconcile, 700); setTimeout(reconcile, 1700);
  }, true);
  var drawer = document.querySelector('cart-drawer');
  if (drawer && window.MutationObserver) new MutationObserver(function () { if (drawer.classList.contains('active') || drawer.classList.contains('is-open') || drawer.hasAttribute('open')) reconcile(); }).observe(drawer, { attributes: true, attributeFilter: ['class', 'open'] });

  /* ---------- Init + total live ---------- */
  function init() { installOptIn(); installLogoPrice(); hideOffertBadge(); updateTotal(); watchDrawerForSink(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  [200, 600, 1500, 3000].forEach(function (t) { setTimeout(init, t); });
  document.addEventListener('input', function (e) { if (e.target && e.target.closest && e.target.closest('.oktgn-flo')) updateTotal(); }, true);
  document.addEventListener('change', function () { updateTotal(); }, true);
  setInterval(updateTotal, 1200);
  setTimeout(reconcile, 900);
  [300, 900, 2000].forEach(function (t) { setTimeout(verrouilleSupplement, t); });
  document.addEventListener('click', function () { setTimeout(verrouilleSupplement, 400); }, true);
})();
